(function () {

  const bookingAppElement = document.querySelector("booking-layout");
  const bookingHash = "/booking/";
  const step1Hash = bookingHash + "step-1";

  if (bookingAppElement) {
    // if the booking hash is set, it will trigger the booking component
    // N.B. This may be a deep link.
    if (!window.location.hash.includes(bookingHash)) {
      // if it's not, change the hash to trigger the booking component
      window.history.replaceState(null, null, "#" + step1Hash);
    }
  }

})();